import { Component, OnInit, ViewChild, ContentChildren, Input } from '@angular/core';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { TotBatchService } from 'projects/services/src/app/API/tot-batch.service';
// tslint:disable-next-line:import-blacklist
import { Subscription } from 'rxjs';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Route } from '@angular/router';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import * as moment from 'moment';
import { FileService } from 'projects/services/src/app/API/document/file.service';
import { BatchService } from 'projects/services/src/app/API/batch.service';
import { ApplicantDataService } from 'projects/services/src/app/applicant-data.service';
declare const swal: any;
declare const toastr: any;
@Component({
	selector: 'app-applicant-preferences',
	templateUrl: './applicant-preferences.component.html',
	styleUrls: ['./applicant-preferences.component.css']
})
export class ApplicantPreferencesComponent implements OnInit {

	userInfo: any;
	applicantInfo: any;
	trainingReqId: Number;
	userName: any;
	batchStatus: any;
	batchId: Number;
	actionTakenForm: FormGroup;
	pageNo = 1;
	state: string;
	district: string;
	subDistrict: string;
	sector: string;
	jobRole: string;
	itemsPerPage = 10;
	userRole: any;
	trainerReqData: any = [];
	searchResult: any;
	JobroleValue;
	searchBatchesForm: FormGroup;
	trFilterForm: FormGroup;
	message: any;
	subscription: Subscription;
	preference: any;
	showPreferenceButton = true;
	data: any;
	startDate = '';
	endDate = '';
	isSearchDisabled = true;
	fromDate = "fromDate";
	toDate = "toDate";
	recordsPerPage: any;
	pageNum: any;
	length: any;
	searchText: any;
	selectStatus = false;
	trainingRequestLists: any[] = [];
	appliedBatch: any;

	searchPreferencesArray:
		Array<{
			state: any,
			district: any,
			subDistrict: any,
			sector: any,
			requestedOnToDate: any,
			requestedOnFromDate: any,
			applicantType: any,
			qpCode: any,
			status: any
		}> = []

	searchObject = {
		sector: '',
		jobRole: '',
		keyword: '',
		sortBy: 'batchId'
	};

	requestStatus = [
		{ name: 'Awaiting Batch Enrollment', value: 'AWAITING_BATCH_ENROLLMENT' },
		{ name: 'Enrolled To Batch', value: 'ENROLLED_TO_BATCH' },
		{ name: 'Fullfilled Through Batch', value: 'FULLFILLED_BY_BATCH' },
		{ name: 'Fullfilled Through Certificate', value: 'FULLFILLED_BY_CERTIFICATE' },
		{ name: 'Pending', value: 'PENDING' },
		{ name: 'Rejected By SSC', value: 'REJECTED_BY_SSC' },
		{ name: 'Removed By Applicant', value: 'REMOVED_BY_APPLICANT' },
	]

	showRequestStatus(status) {
		return {
			'APPROVED': 'Approved',
			'REJECTED': 'Rejected by SSC',
			'PENDING': 'Pending',
			'ENROLLED_TO_BATCH': 'Enrolled to Batch',
			'FULLFILLED_BY_CERTIFICATE': 'Fullfilled through Certificate',
			'REMOVED_BY_APPLICANT': 'Removed by Applicant',
			'AWAITING_BATCH_ENROLLMENT': 'Awaiting Batch Enrollment',
			'FULLFILLED_BY_BATCH': 'Fullfilled through Batch'
		}[status]
	}

	requestStatusColor = {
		APPROVED: '#ef7e22',
		PENDING: '#E0971F',
		REJECTED: '#D9503F',
		ENROLLED_TO_BATCH: '#58A55C',
		FULLFILLED_BY_CERTIFICATE: '#58A55C',
		REMOVED_BY_APPLICANT: '#D9503F',
		AWAITING_BATCH_ENROLLMENT: '#E0971F',
		FULLFILLED_BY_BATCH: '#58A55C'
	}

	trApplicantType = [
		{
			name: 'Trainer',
			value: 'trainer'
		},
		{
			name: 'Master Trainer',
			value: 'masterTrainer'
		}
	]
	arApplicantType = [
		{
			name: 'Assessor',
			value: 'assessor'
		},
		{
			name: 'Master Assessor',
			value: 'masterAssessor'
		}
	]

	startDateObject = {
		date: '',
		placeholder: 'Select the Date',
		format: 'dd/MM/yyyy'
	};
	endDateObject = {
		date: '',
		placeholder: 'Select the Date',
		format: 'dd/MM/yyyy'
	};
	dateObject = {
		date: new Date(),
		placeholder: 'Select Date',
		format: 'dd/MM/yyyy',
		readonly: true
	};

	constructor(
		private currentUserService: CurrentUserService,
		private totBatchService: TotBatchService,
		public _applicantDataService: ApplicantDataService,
		private _totService: TotBatchService,
		private router: Router,
		private formBuilder: FormBuilder,
		private fileService: FileService,
		private batchService: BatchService,
	) {
		this.trFilterForm = this._applicantDataService.trFilterForm;
		this.searchBatchesForm = this._applicantDataService.searchBatchesForm;
		this.subscription = this._applicantDataService.getData().subscribe(message => {
		});
		this.getCurrentUserInfo();
		this.searchFilter();

	}
	ngOnInit() {
		this.getCurrentUserInfo();
		this._applicantDataService.getStates();
		this._applicantDataService.getSectors();
		this._applicantDataService.getJobRoles();
		this._applicantDataService.setData('data');
		this.resetFormData('date');
		this.createActionForm();
		this.resetTrForm();
	}

	createActionForm() {
		this.actionTakenForm = this.formBuilder.group({
			comment: ['', [Validators.required, Validators.maxLength(1000)]],
		});
	}

	goBack() {
		if (this.userRole === 'Trainer') {
			this.router.navigate(['trainer/applicant']);
		} else if (this.userRole === 'Assessor') {
			this.router.navigate(['assessor/applicant']);
		}
		// window.history.back();
		this.resetTrForm();
	}

	searchPreferences(data) {
		// this.searchObject.state = data.state;
		// this.searchObject.district = data.district;
		// this.searchObject.subDistrict = data.subDistrict;
		this.searchObject.sector = data.sector;
		this.searchObject.jobRole = data.jobRole;
		this.totBatchService.getapplicantDataBySearch(this.searchObject, 1, 10).subscribe(
			res => {
				if (res) {
					this.searchResult = res.docs[0].data
					// this._applicantDataService.setData(res.docs[0].data)
				}
			},
			error => {
				this.searchResult = [];
			}
		);
	}

	removePreference(data) {
		swal({
			title: 'Are you sure want to delete the Training Request?',
			text: 'Since you are proceeding to remove the training request which you have updated earlier',
			type: 'warning',
			showCancelButton: true,
			confirmButtonText: 'YES,PROCEED'
		}).then(result => {
			if (result.value) {
				this.JobroleValue = data;
				Helpers.openModal('remove_modal')
			}
		});
	}

	deleteApplicantPref() {
		const model = {
			userName: this.userName,
			trainingReqId: this.JobroleValue.trainingReqId,
			batchId: this.JobroleValue.linkedBatchId ? this.JobroleValue.linkedBatchId : null,
			reason: this.actionTakenForm.value.comment,
		}
		const role = this.userRole ? this.userRole.toLowerCase() : ''
		this.totBatchService.deleteApplicantPreferences(model, role).subscribe(res => {
			if (res) {
				swal({
					title: 'Training Request removed successfully',
					text: 'Your training request listed is successfully removed',
					type: 'success',
					confirmButtonText: 'View All Training Request',
				}).then(result => {
					if (result.value) {
						this.searchFilter();
						this.closeRequestModal();
					}
				});
			}
		}, err => {
			console.log('123123', err);
		});
	}

	closeRequestModal() {
		this.actionTakenForm.reset();
		this.actionTakenForm.get('comment').setValue('');
	}

	getCurrentUserInfo() {
		this.currentUserService.getCurrentUser().subscribe(data => {
			this.userInfo = data;
			this.userRole = data.role;
		});
		// this.userInfo = JSON.parse(localStorage.getItem('loginUserData'))
	}

	getCurrentUserInfo1() {
		this.currentUserService.getCurrentUser().subscribe(currentUser => {
			this.userInfo = currentUser
			// this.currentUserService.setCurrentUser({
			// 	sector: this.userInfo.sector
			// });
			this.userRole = currentUser.role;
		});

	}

	showComments(data) {
		this.preference = data;
	}

	setData(tab?): void {
		console.log("set Data");

		this.searchResult = [];
		// this._applicantDataService.setData('data',tab );
		this._applicantDataService.setData(tab);
		this.showPreferenceButton = true;
		this.resetFormData();
	}

	hideButton(tab) {
		// this._applicantDataService.setData('data',tab);
		this.resetTrForm();
		this._applicantDataService.setData(tab);
		this.searchResult = [];
		this.showPreferenceButton = false;
		this.resetFormData();

	}

	createSearchData(data?, search?) {
		this.data = {
			state: data.state,
			district: data.district,
			subDistrict: data.subDistrict,
			sector: data.sector,
			jobRole: data.jobRole,
			batchType: data.type,
			startDate: this.startDate,
			endDate: this.endDate,
			keyword: search ? search : '',
			sortBy: 'batchId'
		};
		if (this.startDate === '') {
			delete this.data.startDate;
		}
		if (this.endDate === '') {
			delete this.data.endDate;
		}
	}

	resetFormData(name?: any) {
		console.log(this.data);
		this.isSearchDisabled = true;
		this.searchBatchesForm.get('applicantType').setValue('');
		this.searchBatchesForm.get('state').setValue('');
		this.searchBatchesForm.get('district').setValue('');
		this.searchBatchesForm.get('subDistrict').setValue('');
		this.searchBatchesForm.get('sector').setValue('');
		this.searchBatchesForm.get('jobRole').setValue('');
		this.searchBatchesForm.get('keyword').setValue('');
		this.searchBatchesForm.get('type').setValue('');
		if (name === 'date') {
			this.startDateObject.date = '';
			this.endDateObject.date = '';
			console.log('STRING');
		} else {
			this.startDateObject.date = null;
			this.endDateObject.date = null;
			console.log('NULL');
		}
		delete this.startDate;
		delete this.endDate;
		this._applicantDataService.districts = [];
		this._applicantDataService.subDistricts = [];
		this._applicantDataService.jobRoles = [];
		this.searchBatchesForm.markAsUntouched();
		console.log(this.data);
	}

	search() {
		this.createSearchData(this.searchBatchesForm.value);
		if (this.data === undefined) {
			this.isSearchDisabled = true;
		} else {
			this.isSearchDisabled = false;
		}
		this.updateDataType();
		this.setValidation(null);
		if (this.startDate) {
			this.data['startDate'] = this.startDate;
		}
		if (this.endDate) {
			this.data['endDate'] = this.endDate;
		}
		this._totService
			.getapplicantDataBySearch(this.data, this.pageNum, this.recordsPerPage).subscribe(
				res => {
					console.log(res);
					this.searchResult = res.docs[0].data;
					this.length = res.docs[0].count;
				},
				error => {
					this.searchResult = [];
					console.log("erooooooooo");

				}
			);
		this.setValidation(null);
		this.resetFormData();
	}

	updateDataType() {
		Object.keys(this.data).forEach(key => {
			console.log('sdsfg', this.data[key]);
			if (this.data[key] === '') {
				console.log('key', key);
				this.data[key] = null;
				if (key === 'batchType') {
					this.data.batchType = '';
				}
				this.data.keyword = this.searchText === '' ? '' : 'tcName:' + this.searchText;
			}
		});
		console.log('data', this.data);
	}

	setValidation(validation?) {
		const fields = ['state', 'sector', 'jobRole'];
		fields.map(field => this.setValidationOnField(field, validation));
	}

	setValidationOnField(name, validation) {
		this.searchBatchesForm.get(name).setValidators(validation);
		this.searchBatchesForm.get(name).updateValueAndValidity();
	}

	addJobRole() {
		Helpers.closeModal('preferences_modal')
		const data = {
			state: this.searchBatchesForm.value.state,
			district: this.searchBatchesForm.value.district,
			subDistrict: this.searchBatchesForm.value.subDistrict,
			sector: this.searchBatchesForm.value.sector,
			// subSector: this.searchBatchesForm.value.subSector,
			applicantType: this.searchBatchesForm.value.applicantType,
			jobRole: this.searchBatchesForm.value.jobRole,
			batchType: this.searchBatchesForm.value.type ? this.searchBatchesForm.value.type : '',
			startDate: this.startDate ? this.startDate : '',
			endDate: this.endDate ? this.endDate : '',
			keyword: this.searchText === '' ? '' : 'tcName:' + this.searchText
		};
		this.setValidation([Validators.required]);
		if (this.searchBatchesForm.valid) {
			this._totService.updateApplicantPreferences(data).subscribe(res => {
				if (res) {
					swal({
						title: 'Training Request Created Successfully',
						text: 'You have successfully created a new training request',
						type: 'success',
						confirmButtonText: 'View All Training Request',
					});
					this.searchFilter()
				}
			});
		} else {
			toastr.error('Please select all sector details and state.');
		}
		this.resetFormData();
		console.log("reset");

	}

	getSelectedData() {
		this.createSearchData(this.searchBatchesForm.value);
		console.log(this.data);
		if (this.data === undefined) {
			this.isSearchDisabled = true;
		} else {
			this.isSearchDisabled = false;
		}
	}

	searchFilter() {
		console.log(this.trFilterForm);
		const searchFilterObject = {
			state: this.trFilterForm.value.state ? this.trFilterForm.value.state.code : 0,
			district: this.trFilterForm.value.district ? this.trFilterForm.value.district.code : 0,
			subDistrict: this.trFilterForm.value.subDistrict ? this.trFilterForm.value.subDistrict.code : 0,
			sector: this.trFilterForm.value.sector ? Number(this.trFilterForm.value.sector.sectorID) : null,
			applicantType: this.trFilterForm.value.applicantType ? this.trFilterForm.value.applicantType : '',
			qpCode: this.trFilterForm.value.jobRole ? this.trFilterForm.value.jobRole.qpCode : '',
			version: this.trFilterForm.value.jobRole ? this.trFilterForm.value.jobRole.version : '',
			status: this.trFilterForm.value.status ? this.trFilterForm.value.status : '',
			requestedOnFromDate: this.changeDateFormat(this.trFilterForm.value.startDate) ? this.changeDateFormat(this.trFilterForm.value.startDate) : null,
			requestedOnToDate: this.changeDateFormat(this.trFilterForm.value.endDate) ? this.changeDateFormat(this.trFilterForm.value.endDate) : null,
		}
		this.getTrainingReqData(searchFilterObject);
	}

	changeDateFormat(date) {
		if (date) {
			return new Date(date).toISOString();
		}
	}

	getTrainingReqData(searchFilterObject) {
		this._totService.searchFormData(searchFilterObject).subscribe(
			res => {
				if (res) {
					this.userName = res[0].userName;
					this.trainerReqData = res[0].preferences;
					if (res[0].preferences && res[0].preferences.linkedBatchId) {
						this.batchId = res[0].preferences.linkedBatchId;
					}
				}
			}
		);
	}

	getApplicantCertificateDetails(data) {
		console.log(data);
		data['userName'] = this.userName;
		this.totBatchService.getApplicantcertificateDetails(data).subscribe(res => {
			console.log(res);
			if (res !== null) {
				this.downloadApplicantCertificate(res[0]._id.certificateDetails)
			} else {
				toastr.error('No certificate available');
			}

		})
	}

	navigateTo(trData) {
		this.batchService.getBatchDetail(trData.linkedBatchId).subscribe(batch => {
			if (batch.status) {
				this.router.navigate([`trainer/applicant/view-batch-details/${batch.status}/${trData.linkedBatchId}`]);
			}
		})
	}

	downloadApplicantCertificate(certificateDetails) {
		const url = certificateDetails.certificateURLDetails.location ? certificateDetails.certificateURLDetails.location : certificateDetails.certificateURLDetails.key;
		this.fileService.downloadAttachedFile(url);
	}



	resetTrForm() {
		this.trFilterForm.reset();
		this.trainerReqData = [];
		this._applicantDataService.districts = [];
		this._applicantDataService.subDistricts = [];
		this._applicantDataService.jobRoles = [];
		this.searchFilter();
	}

	startDateTR(event) {
		if (event.target.value) {
			const [day, month, year] = (event.target.value).split('/');
			const formattedDate = moment(new Date(year, month - 1, day)).format('YYYY-MM-DD');
			this.trFilterForm.get('startDate').setValue(formattedDate);
		}
	}

	endDateTR(event) {
		if (event.target.value) {
			console.log(event.target.value, "target");
			const [day, month, year] = (event.target.value).split('/');
			const formattedDate = moment(new Date(year, month - 1, day)).format('YYYY-MM-DD');
			this.trFilterForm.get('endDate').setValue(formattedDate);
		}
	}

	showViewlinkRequestModel(event) {
		console.log(this.userRole)
		if (event) {
			this.trainingRequestLists = [];
			if (event && event.data) {
				this.appliedBatch = event.data
			}
			const qpCode = this.getBatchJobRoles(this.appliedBatch)
			const data = {
				qpCodes: qpCode,
			}
			this._totService.getTrainingRequestListToLinkWithBatch(data, this.userRole).subscribe(res => {
				console.log(res);
				if (res && res.Approved.length && res.Approved[0]['preferences'] && res.Approved[0]['preferences'].length > 0) {
					this.trainingRequestLists = res.Approved[0].preferences;
					console.log(this.trainingRequestLists, "CHECKING");
					Helpers.openModal('linkTrainingRequests');
				} else {
					this.linkTrainingRequest(res['Pending'])
				}
			})

		}
	}

	getBatchJobRoles(batch) {
		let jobRoles = []
		batch.jobRoles.map(jobRole => {
			if (!jobRole.isPlatformQP) {
				jobRoles.push({
					'qpCode': jobRole.qpCode,
					'version': jobRole.version
				})
			}
		});
		return jobRoles;
	}

	selectAll() {
		if (this.selectStatus) {
			this.selectStatus = false;
			for (let index = 0; index < this.trainingRequestLists.length; index++) {
				this.trainingRequestLists[index].isSelected = false;
			}
		} else {
			this.selectStatus = true;
			for (let index = 0; index < this.trainingRequestLists.length; index++) {
				this.trainingRequestLists[index].isSelected = true;
			}
		}
	}

	selectOne(index) {
		this.trainingRequestLists[index]['isSelected'] = !this.trainingRequestLists[index].isSelected;
	}

	resetAllCandidates() {
		this.selectStatus = false;
		for (let index = 0; index < this.trainingRequestLists.length; index++) {
			this.trainingRequestLists[index]['isSelected'] = false;
		}
	}

	linkTrainingRequest(pending?) {
		pending ? pending = pending : pending = [];
		let trainingRequest = [];
		if (this.trainingRequestLists.length > 0) {
			for (let index = 0; index < this.trainingRequestLists.length; index++) {
				if (this.trainingRequestLists[index].isSelected) {
					trainingRequest.push(this.trainingRequestLists[index].trainingReqId)
				}
			}
			const data = {
				trIds: trainingRequest,
				status: 'AWAITING_BATCH_ENROLLMENT',
				batchId: this.appliedBatch.batchId
			}
			if (trainingRequest.length > 0) {
				this.batchService.applyForBatch(this.appliedBatch.batchId, this.appliedBatch.type).subscribe(res => {
					console.log(res);
					if (res) {
						swal(
							'Applied Successfully',
							`You have successfully applied for ${this.appliedBatch.batchName},
							For next steps, please coordinate with concerned SSC.`,
							//  + 'and batch id - ' + data.batchId
							'success'
						);
						this._totService.linkTrainingRequestToBatch(data, this.userRole).subscribe(res => {
							console.log(res);
							if (res) {
								// swal('Training Request Updated Successfully', '', 'success');
								// Helpers.closeModal('linkTrainingRequests');
							}
						})
					}
				});
			} else {
				toastr.error('Please select at least one Training request');
			}
		} else if (pending && pending.length > 0 && pending[0]['pendingCount'] > 0) {
			swal('Unable to process your request!', `You can't apply to the batch <b> ${this.appliedBatch.batchName} </b>
			 as your relevant Training Requests is under review by SSC.
			On receipt of approval from SSC, you would be able to apply to the batch.`, 'warning');
		} else {
			swal('No Training Request Raised', `You can't apply to the batch <b> ${this.appliedBatch.batchName} </b>
			as there is no Training Request raised in the specified job role.
			Please raise a Training Request, to proceed. The same shall be reviewed by the SSC.`, 'warning');
		}
	}
}
